module.exports = __webpack_public_path__ + "static/media/czskiLogo.cdb0969a.svg";